import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {AdminService} from '../../../admin/admin.service';
import {IAnalyticsService} from './ianalyticsservice';
import {NoOpAnalyticsService} from './noop-analytics.service';

declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  private ga: IAnalyticsService;
  private googleAnalyticsTag: string;

  constructor(private router: Router, private adminService: AdminService) {
    this.adminService.finishedCheckingApps$.subscribe((checkedApps) => {
      if (environment.enableAnalytics && checkedApps) {
        this.googleAnalyticsTag = this.adminService.isInLiteMode() ? environment.googleAnalyticsDTLite : environment.googleAnalytics;
        this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe((e: NavigationEnd) => {
          gtag('js', new Date());
          gtag('config', this.googleAnalyticsTag);
        });
      }
    });
  }

  init() {
    if (environment.enableAnalytics) {
      this.initialiseGoogleAnalytics();
    } else {
      this.ga = NoOpAnalyticsService;
    }

    this.uiInfo();
  }

  customEvent(eventName: string, value?: any, data?: {}): void {
    let eventData: any = {};
    if (data)
      eventData = data;
    if (value)
      eventData.value = value;

    this.ga.recordEvent(eventName, eventData);
  }

  private initialiseGoogleAnalytics(): void {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.googleAnalyticsTag;
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    const gtagEl = document.createElement('script');
    const gtagBody = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '` + this.googleAnalyticsTag + `');
    `);
    gtagEl.appendChild(gtagBody);
    document.body.appendChild(gtagEl);

    // wrapper around the gtag function
    this.ga = {
      recordEvent(eventType: string, eventData: object) { gtag('event', eventType, eventData); },
      recordError(error: any) { gtag('event', 'ERROR', error); }
    };
  }

  private uiInfo(): void {
    this.reportViewportSize();
    this.darkMode();
    this.customEvent('kp_app_version', environment.version);
    this.customEvent('screen_scaling', window.devicePixelRatio * 100 + '%');
  }

  private reportViewportSize(): void {
    let width = window.innerWidth;
    let height = window.innerHeight;

    width = Math.round(width / 100) * 100;
    height = Math.round(height / 100) * 100;

    const size = width + 'x' + height;
    this.customEvent('viewport_size', size);
  }

  private darkMode(): void {
    const mode = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'darkMode' : 'lightMode';
    this.customEvent(mode);
  }
}
